import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useCompare } from "@/context/CompareContext";
import { Button } from "@/components/ui/button";
import { GitCompareArrows, X } from "lucide-react";

export function CompareTray() {
  const { ids, clear, max } = useCompare();
  const navigate = useNavigate();

  return (
    <AnimatePresence>
      {ids.length > 0 && (
        <motion.div
          initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-xl"
          data-testid="compare-tray">
          <div className="bg-obsidian text-white rounded-sm shadow-2xl px-4 py-3 flex items-center gap-4">
            <div className="flex items-center gap-2 flex-1">
              <GitCompareArrows className="w-5 h-5 text-blaze shrink-0" />
              <span className="text-sm font-600">
                <b>{ids.length}</b> de {max} selecionados para comparar
              </span>
            </div>
            <Button size="sm" variant="ghost" className="text-white/60 hover:text-white hover:bg-white/10" onClick={clear} data-testid="compare-clear">
              <X className="w-4 h-4 mr-1" /> Limpar
            </Button>
            <Button size="sm" className="bg-blaze hover:bg-white hover:text-obsidian text-white font-700 rounded-sm"
              disabled={ids.length < 2} onClick={() => navigate("/comparar")} data-testid="compare-go">
              Comparar {ids.length >= 2 ? `(${ids.length})` : ""}
            </Button>
          </div>
          {ids.length < 2 && <p className="text-center text-xs text-white/50 mt-1">Selecione pelo menos 2 carros</p>}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
